import { z } from "zod";
import { IntegrationBaseSchema, IntegrationKey } from "./base";

/**
 * Slack Integration Settings Schema
 *
 * The Slack app's credentials (signing secret, bot token) live in backend
 * env config — never in per-org settings. Installing the integration is
 * what binds inbound Slack webhooks to the organization: the webhook
 * receiver resolves the target org from the installed integration row.
 *
 * `teamId` optionally pins the integration to a specific Slack workspace.
 * When set, inbound webhooks from other workspaces are not attributed to
 * this org. Leave empty for single-workspace deployments.
 */
export const SlackIntegrationSettingsSchema = z.object({
  teamId: z.string().optional(),
});

export type SlackIntegrationSettings = z.infer<
  typeof SlackIntegrationSettingsSchema
>;

export const SlackIntegrationSettingsSchemaWithoutBase = z.object({
  key: z.literal(IntegrationKey.Slack),
  settings: SlackIntegrationSettingsSchema,
});

export const SlackIntegrationSchema = IntegrationBaseSchema.merge(
  SlackIntegrationSettingsSchemaWithoutBase,
);

export type SlackIntegration = z.infer<typeof SlackIntegrationSchema>;
